import React, { useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from "react-router-dom";
import CryptoJS from 'crypto-js'; // Importar la biblioteca crypto-js
import BASE_URL from '../config/config';

const IniciarSesion = () => {
  const [usuario, setUsuario] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [error, setError] = useState('');

  const navigate = useNavigate();

  const handleUsuarioChange = (event) => {
    // Mantener el valor tal cual (no convertir a minúsculas para emails)
    setUsuario(event.target.value);
  };

  const handleContrasenaChange = (event) => {
    setContrasena(event.target.value);
  };

  const handleSubmit = async () => {
    try {
      // Encriptar la contraseña en MD5 antes de enviarla
      const contrasenaEncriptada = CryptoJS.MD5(contrasena).toString();

      const response = await axios.post(`${BASE_URL}/login`, { 
        usuario: usuario.toLowerCase(), // Normalizar a minúsculas para la búsqueda
        contrasena: contrasenaEncriptada
      });
      
      if (response.status === 200) {
        // Iniciar sesión exitosa, redirigir al usuario
        localStorage.setItem("AuthToken", response.data.jwt_token);
        window.location.reload();
      } else {
        // Inicio de sesión fallido, mostrar mensaje de error
        setError(response.data.message);
      }
    } catch (error) {
      console.error('Error al iniciar sesión:', error);
      setError('Error al iniciar sesión. Por favor, inténtalo de nuevo.');
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <main className='inicia-sesion site-width'>
      <div className='formulario-inicio'>
        <div className="logo-form-inicio">
          <img src="/images/logoadhoc.svg" alt="Logo ADHOC" />
          <p className="p-soporte">v1.3.0</p>
        </div>
        <h1>Inicia sesión</h1>
        <p>¡Nos alegra tenerte de vuelta! Entra y comparte con nosotros tu tarea/incidencia.</p>
        <div className='campos-inicio'>
          <div className="campo-inicio">
            <label htmlFor="user">Usuario o correo electrónico</label>
            <input autoComplete="off" type="text" id="user" value={usuario} onChange={handleUsuarioChange} placeholder='Escribe aquí tu usuario o correo electrónico...' />
          </div>
          <div className="campo-inicio">
            <label htmlFor='password'>Contraseña</label>
            <input autoComplete="off" type="password" name="password" value={contrasena} onChange={handleContrasenaChange} id="password" placeholder='Escribe aquí tu contraseña...' onKeyDown={handleKeyDown} />
          </div> 
          <p className='lost-password'>¿Has olvidado tu contraseña? <Link to={'/recuperar-contrasena'}>Solicita una nueva</Link></p>
          {error && <p className="error">{error}</p>}
          <button type="button" onClick={handleSubmit}>Acceder a mi cuenta</button>
        </div>
      </div>
    </main>
  );
};

export default IniciarSesion;
